import { render } from "./NavBarComp.vue?vue&type=template&id=30711126"
import script from "./NavBarComp.vue?vue&type=script&lang=js"
export * from "./NavBarComp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\deploy\\ths\\evangelism_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__